export default "__VITE_ASSET__bOxt71AF__"